import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { IconButton, Paper, Stack, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function DocumentLink({ document, handleDeleteDocument, handleUpdateDocument }) {
  const { t } = useTranslation();
  const [documentData, setDocumentData] = useState({
    id: document.id,
    documentName: document.documentName,
    link: document.link,
  });

  const handleTextFields = (event) => {
    const { name, value } = event.target;
    const newState = { ...documentData };
    newState[name] = value;
    setDocumentData(newState);
  };

  const [toggleEdit, setEdit] = useState(false);
  const handleEdit = () => {
    setEdit(!toggleEdit);
  };

  const handleSave = () => {
    const newState = { ...documentData };
    handleUpdateDocument(newState);
    handleEdit();
  };

  useEffect(() => {
    if (documentData.link === '' || undefined) {
      setEdit(true);
    }
  }, []);

  return (
    <Paper variant="elevation" subtype="documentField">
      <Stack variant="documentField" direction="row" py={0.5} px={2}>
        {toggleEdit ? (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            spacing={2}
            width="100%"
            pr={4}
            py="12px"
          >
            <TextField
              variant="outlined"
              size="small"
              subtype="documentField"
              onChange={(event) => handleTextFields(event)}
              id="documentName"
              name="documentName"
              placeholder={t('document.documentName')}
              value={documentData.documentName}
              fullWidth
            />
            <TextField
              variant="outlined"
              size="small"
              subtype="documentField"
              onChange={(event) => handleTextFields(event)}
              id="link"
              name="link"
              placeholder={t('document.link')}
              value={documentData.link}
              fullWidth
            />
          </Stack>
        ) : (
          <a
            href={
              documentData.link.startsWith('https://') || documentData.link.startsWith('http://')
                ? documentData.link
                : `//${documentData.link}`
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            <Typography variant="documentLink" color="primary">
              {documentData.documentName}
            </Typography>
          </a>
        )}

        <Stack direction="row">
          {toggleEdit ? (
            <IconButton id="save-link" size="small" name="savelink" onClick={handleSave}>
              <SaveOutlinedIcon />
            </IconButton>
          ) : (
            <IconButton id={`${documentData.documentName}-edit-link`} size="small" name="editLink" onClick={handleEdit}>
              <EditOutlinedIcon />
            </IconButton>
          )}
          <IconButton id="delete-link" size="small" name="documentation" onClick={() => handleDeleteDocument(document.id)}>
            <DeleteOutlineIcon />
          </IconButton>
        </Stack>
      </Stack>
    </Paper>
  );
}
export default DocumentLink;
